import { Table } from 'edenred-ui';
import styled from 'styled-components';

export const StyledTableCell = styled(Table.Cell)`
  background-color: ${({ theme }) => theme.warningBackgroundColor};
  font-size: ${({ theme }) => theme.sizeSmall} !important;
`;

export const ErrorLine = styled.p`
  margin: 0;
  padding: 0;
  line-height: ${({ theme }) => theme.sizeMedium};
  color: ${({ theme }) => theme.warningColor};
`;

export const ErrorValue = styled.span`
  color: ${({ theme }) => theme.warningColor};
  font-weight: ${({ theme }) => theme.fontSemiBold};
`;
